import React from "react";
import SystemActivityDashboard from "./SystemActivityDashboard";

const Dashboard = () => (
  <div className="page-content piers-page">
    <SystemActivityDashboard />
  </div>
);

export default Dashboard;
